import { render } from "./LayoutSettings2Cols.vue?vue&type=template&id=13407d10&scoped=true"
const script = {}

import "./LayoutSettings2Cols.vue?vue&type=style&index=0&id=13407d10&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13407d10"]])

export default __exports__